import { createWebHistory, createRouter } from "vue-router";
import axios from 'axios';
import routes from './routes';
import appConfig from "../../app.config";

const router = createRouter({
  history: createWebHistory('/'),
  routes,
  // Use the HTML5 history API (i.e. normal-looking routes)
  // instead of routes with hashes (e.g. example.com/#/about).
  // This may require some server configuration in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  mode: 'history',
  // Simulate native-like scroll behavior when navigating to a new
  // route and using back/forward buttons.
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0, left: 0 };
    }
  },
});

// API based Authentication
// Before each route evaluates...
router.beforeEach(async (routeTo, routeFrom, next) => {

  const authRequired = routeTo.matched.some((route) => route.meta.authRequired);

  if (!authRequired) return next();

  axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt'); // for all requests
  // await axios.get('https://api-node.themesbrand.website/profile').then((data) => {
  //   localStorage.setItem('userdata', JSON.stringify(data.data.user));
  //   localStorage.setItem('userid', data.data.user._id);
  //   localStorage.setItem('user', JSON.stringify(data.data.user));
    next();
  // }).catch(() => {
  //   next();
  //   // next({ name: 'login', query: { redirectFrom: routeTo.fullPath } });
  // });
});

router.beforeEach((routeTo, routeFrom, next) => {

  const publicPages = [
    process.env.VUE_APP_DB_URI + '/login',
    process.env.VUE_APP_DB_URI + '/resetPwd',
    process.env.VUE_APP_DB_URI + '/installation',
    process.env.VUE_APP_DB_URI + '/action-alert-message',
    process.env.VUE_APP_DB_URI + '/activateOTP'];
  const authpage = publicPages.includes(routeTo.path);
  const loggeduser = localStorage.getItem('user');

  // 根据发送的邮件中地址，匹配path中包含/#/ 的路由，根据正则匹配，移除掉/#
  if(routeTo.href.includes('/#')) {
    window.location.href =  routeTo.href.replace('/#', '')
  }

  // 在全部挂载之前对路由进行处理
  let pageHistory = JSON.parse(localStorage.getItem('pageHistory')) || [];
  
  // 定义排除路径
  const excludedPaths = ['/undefined', '/installation', '/action-alert-message', '/login', '/resetPwd', '/activateOTP'];
  
  // 检查路径中是否包含excludedPaths数据中的任意一项，如果包含，则不进行记录
  const checkPath = excludedPaths.some(item => routeTo.path.includes(item));
  if(checkPath) {
    return next();
  }

  // 获取当前路径（移除环境前缀）
  const currentPath = routeTo.path.replace(process.env.VUE_APP_DB_URI, '');
  
  // 判断是否为详情页或数据页（包含动态参数的路径）
  const isDetailPage = currentPath.includes('/detail/') ||
                      currentPath.includes('/edit/') ||
                      currentPath.includes('/view/') ||
                      currentPath.includes('/dict-data/') ||
                      /\d+$/.test(currentPath.split('/').pop());
  
  if (isDetailPage) {
    // 对于详情页，提取基础路径前缀（如 /device/detail）
    const pathParts = currentPath.split('/');
    const basePath = pathParts.slice(0, -1).join('/'); // 移除最后的ID参数
    
    // 查找相同基础路径的现有记录
    const existingIndex = pageHistory.findIndex(item => {
      const itemParts = item.path.split('/');
      const itemBasePath = itemParts.slice(0, -1).join('/');
      return itemBasePath === basePath || item.path.startsWith(basePath);
    });
    
    if (existingIndex !== -1) {
      // 替换现有的详情页记录
      pageHistory[existingIndex] = {
        path: currentPath,
        title: routeTo.name,
        key: pageHistory[existingIndex].key // 保持原有的key值
      };
    } else {
      // 添加新的详情页记录
      const maxKey = pageHistory.length > 0 ? Math.max(...pageHistory.map(item => item.key)) : 0;
      pageHistory.push({
        path: currentPath,
        title: routeTo.name,
        key: maxKey + 1
      });
    }
  } else {
    // 对于普通页面，检查是否已存在相同路径
    const existingIndex = pageHistory.findIndex(item => item.path === currentPath);
    
    if (existingIndex === -1) {
      // 路径不存在，添加新记录
      const maxKey = pageHistory.length > 0 ? Math.max(...pageHistory.map(item => item.key)) : 0;
      pageHistory.push({
        path: currentPath,
        title: routeTo.name,
        key: maxKey + 1
      });
    }
    // 如果路径已存在，不做任何处理（保持原有顺序）
  }
  
  // 保存更新后的历史记录
  localStorage.setItem('pageHistory', JSON.stringify(pageHistory));
    // next();
  // });

  if (!authpage && !loggeduser) {
    return next(process.env.VUE_APP_DB_URI + '/login');
  }

  next();
});

router.beforeResolve(async (routeTo, routeFrom, next) => {
  // try {
  //   // For each matched route...
  //   for (const route of routeTo.matched) {
  //     await new Promise((resolve, reject) => {
  //       // If a `beforeResolve` hook is defined, call it with
  //       // the same arguments as the `beforeEnter` hook.
  //       if (route.meta && route.meta.beforeResolve) {
  //         route.meta.beforeResolve(routeTo, routeFrom, (...args) => {
  //           // If the user chose to redirect...
  //           if (args.length) {
  //             // If redirecting to the same route we're coming from...
  //             // Complete the redirect.
  //             next(...args);
  //             reject(new Error('Redirected'));
  //           } else {
  //             resolve();
  //           }
  //         });
  //       } else {
  //         // Otherwise, continue resolving the route.
  //         resolve();
  //       }
  //     });
  //   }
  //   // If a `beforeResolve` hook chose to redirect, just return.
  // } catch (error) {
  //   return;
  // }
  // document.title = routeTo.meta.title + ' | ' + appConfig.title;
  document.title = appConfig.title;
  // If we reach this point, continue resolving the route.
  next();
});

export default router;
